"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _circularJson = _interopRequireDefault(require("circular-json"));

var _util = require("util");

var replacer = function replacer(key, value) {
  if (key === '_owner') {
    return undefined;
  }

  return value;
};

var changeCheck = function changeCheck(keysToCheck, old, next) {
  for (var i = 0; i < keysToCheck.length; i++) {
    var before = old[keysToCheck[i]];
    var after = next[keysToCheck[i]];

    if (after ? !before : before) {
      return true;
    }

    if ((0, _util.isPrimitive)(after) && (0, _util.isPrimitive)(before)) {
      if (after !== before) {
        return true;
      }
    } else if (_circularJson.default.stringify(after, replacer) !== _circularJson.default.stringify(before, replacer)) {
      return true;
    }
  }

  return false;
};

var _default = changeCheck;
exports.default = _default;